
export default {
  inject: ['product', 'wording'],
  data() {
    return {
      product: this.product,
      wording: this.wording,
    }
  },
  computed: {
    features() {
      if (this.product.features && this.product.features.length > 0) {
        return this.wording.features_list.filter((feature) =>
          this.product.features.includes(feature.key)
        )
      } else return []
    },
  },
}
